/**
 * @file Translation resources for the application. Must follow i18n resource structure.
 */

import translationEn from './translations/en.json';

/**
 * @typedef TranslationConfig
 * @property {{[key: string]: string}} translation i18n translation values.
 */

/**
 * @typedef {{[key: string]: TranslationConfig}} TranslationsConfig
 */

/** @type {TranslationsConfig} */
export default {
  en: {
    translation: translationEn,
  },
};
